<template>
  <v-container>
    <v-row justify="center">
      <v-col md="6">
        <h4 class="text-h4 py-6">
          MSA End-User Training
        </h4>
        <v-card>
          <v-card-title>
            {{ status }}
          </v-card-title>
          <v-card-text>
            <p class="font-weight-bold">{{ statusText }}</p>

            <v-btn
              color="primary"
              v-show="showLogIn"
              @click="switchAccount"
            >
              Log Out
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'
import auth from '../auth'

import {
  getEnv,
  externalRedirect,
  externalRedirectCallback
} from '../utilities'

export default {
  name: 'EndUserTrainingView',

  props: {
    state: String,
    nonce: String,
    memberNumber: String,
    msaPersonId: String
  },

  data: () => ({
    status: 'Redirecting...',
    statusText: 'Please wait.',
    showLogIn: false
  }),

  methods: {
    redirect () {
      const msaPersonId = auth.userProfile?.msaPersonId

      if (!(msaPersonId && this.memberNumber)) {
        this.onWrongAccount()
        return
      }

      // This feature added after initial deployment, only do this if the parameter is supplied to avoid breaking emails already sent out.
      if (this.msaPersonId && (msaPersonId !== parseInt(this.msaPersonId, 10))) {
        this.onWrongAccount()
        return
      }

      externalRedirect(getEnv('VUE_APP_END_USER_PORTAL_URL'), {
        msaPersonId,
        memberNumber: this.memberNumber
      })
    },

    async redirectCallback () {
      this.status = 'Finalising your training...'
      this.statusText = 'Please wait.'
      const data = externalRedirectCallback(this.state, this.nonce)

      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($msaPersonId: Int!, $memberNumber: String!) {
            personCompleteEndUserTraining(msaPersonId: $msaPersonId, memberNumber: $memberNumber)
          }`,
          variables: {
            msaPersonId: data.msaPersonId,
            memberNumber: data.memberNumber
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }
      this.status = 'Training Complete'
      this.statusText = 'You may close this page.'
    },

    onError (e) {
      this.status = 'Something went wrong'
      this.statusText = 'Please try logging out, and try again. If the issue persists, please contact MSA.'
      if (e) this.$emit('error', e)
    },

    onWrongAccount () {
      this.status = 'Incorrect user account for invitation.'
      this.statusText = 'The account that is logged in is associated to another user or MSA Member. To complete your training, please log out and try the invite link again with the correct credentials.'
      this.showLogIn = true
    },

    async switchAccount () {
      await this.$auth.signOut()
    }
  },

  mounted () {
    if (this.state && this.nonce) {
      this.redirectCallback()
    } else {
      this.redirect()
    }
  }
}
</script>
